<template>
  <InfiniteScroll
    :is-loading="isLoading"
    :is-busy="isLoading || isLastNotificationsPage"
    @reached="fetch"
  >
    <div
      v-if="notifications.length"
      class="notification__list"
    >
      <NotificationItem
        v-for="(notification, i) in notifications"
        :key="i"
        :notification="notification"
      />
    </div>

    <div v-else-if="!isLoading" class="text-center pt-4 pb-4">
      <i>Tudo parece tão calmo por aqui ~.~</i>
    </div>
  </InfiniteScroll>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import NotificationItem from '@/components/notification/NotificationItem'
  import InfiniteScroll from '@/components/layout/InfiniteScroll'

  export default {
    components: {
      NotificationItem,
      InfiniteScroll,
    },

    data: () => ({
      notificaitons: [],
      isLoading: false,
      page: 1
    }),

    mounted () {
      this.resetNotificaitons()
      this.trackOpenNotificationsEvent()
    },

    computed: {
      ...mapGetters('notification', [
        'notifications',
        'isLastNotificationsPage'
      ])
    },

    methods: {
      ...mapActions('notification', [
        'fetchNotifications',
      ]),

      ...mapMutations('notification', [
        'resetNotificaitons'
      ]),

      trackOpenNotificationsEvent () {
        this.$gtm.trackEvent({ event: 'notifications.open-list' })
      },

      async fetch () {
        this.isLoading = true

        await this.fetchNotifications()

        this.isLoading = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .notification__list {
    & > *:not(:last-child) {
      margin-bottom: 3px;
      padding-bottom: 3px;
    }
  }
</style>